import '@angular/localize/init';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { register as registerSwiperElements } from 'swiper/element/bundle';

export function getBaseUrl()
{
	if (environment.production)
		return "https://ampere.energiecondivise.it/";
	else
		//return 'https://localhost:55873/';
		return 'https://localhost:53921/';
}

const providers =
	[
		{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
	];

if (environment.production)
{
	enableProdMode();
}

// register Swiper custom elements
registerSwiperElements();

platformBrowserDynamic(providers).bootstrapModule(AppModule)
	.catch(err => console.log(err));